var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnectImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-281 14H533C539.075 14 544 18.9249 544 25H-281V14Z",
    fill: "#CED5EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M592 62H543C536.925 62 532 57.0751 532 51H592V62Z",
    fill: "#CED5EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M617 70H600C595.582 70 592 66.4183 592 62V57H617V70Z",
    fill: "#0B173D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M617 44H600C595.582 44 592 47.5817 592 52V57H617V44Z",
    fill: "#1D42AC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M642 32H625C620.582 32 617 35.5817 617 40V57H642V32Z",
    fill: "#0B173D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M667 32H642V57H667V32Z",
    fill: "#1D42AC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M679 26H667V57H679V26Z",
    fill: "#CED5EF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M703 44C703 40.6863 700.314 38 697 38H679V50H697C700.314 50 703 47.3137 703 44Z",
    fill: "#1D42AC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M543.998 25H526C526 25 528.933 25.188 531 27.5C532.146 28.7816 531.998 31 531.998 31V50C531.998 50.5523 532.446 51 532.998 51H548C548 51 545.5 50.5 544.5 48.5C543.855 47.2095 543.998 46 543.998 46V25Z",
    fill: "#1D42AC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M703 69C703 65.6863 700.314 63 697 63H679V75H697C700.314 75 703 72.3137 703 69Z",
    fill: "#0B173D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M679 56H667V87H679V56Z",
    fill: "#1D42AC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M642 82H625C620.582 82 617 78.4183 617 74V57H642V82Z",
    fill: "#1D42AC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M667 82H642V57H667V82Z",
    fill: "#CED5EF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M688 0H702C702 7.73199 695.732 14 688 14V0Z",
    fill: "#1D42AC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M688 98H702C702 105.732 695.732 112 688 112V98Z",
    fill: "#CED5EF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1720 100H905C898.925 100 894 95.0751 894 89H1720V100Z",
    fill: "#FFD437"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M846 52H895C901.075 52 906 56.9249 906 63H846V52Z",
    fill: "#FFD437"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M821 44H838C842.418 44 846 47.5817 846 52V57H821V44Z",
    fill: "#A27F03"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M821 70H838C842.418 70 846 66.4183 846 62V57H821V70Z",
    fill: "#DFAF00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M796 82H813C817.418 82 821 78.4183 821 74V57H796V82Z",
    fill: "#A27F03"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M771 82H796V57H771V82Z",
    fill: "#DFAF00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M759 88H771V57H759V88Z",
    fill: "#FFD437"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M894.002 89H912C912 89 909.067 88.812 907 86.5C905.854 85.2184 906.002 83 906.002 83V64C906.002 63.4477 905.554 63 905.002 63H890C890 63 892.5 63.5 893.5 65.5C894.145 66.7905 894.002 68 894.002 68V89Z",
    fill: "#DFAF00"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M759 58H771V27H759V58Z",
    fill: "#DFAF00"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M796 32H813C817.418 32 821 35.5817 821 40V57H796V32Z",
    fill: "#DFAF00"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M771 32H796V57H771V32Z",
    fill: "#FFD437"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M737 26H751C751 18.268 744.732 12 737 12V26Z",
    fill: "#FFD437"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M751 98H737C737 90.268 743.268 84 751 84V98Z",
    fill: "#DFAF00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectImg);
export default __webpack_public_path__ + "static/media/connect-img.fef5c34c2042f6305555893f76539950.svg";
export { ForwardRef as ReactComponent };